module.exports = __webpack_public_path__ + "static/huffington-post-grey.b5e35283.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/press/huffington-post-grey.svg
// module id = 1706
// module chunks = 35783957827783